import React, { useEffect } from "react";
import "./UpdateTask.css";
import { useDispatch, useSelector } from "react-redux";
import UpdateSession from "./UpdateSession/UpdateSession";
import Locale from "../../locales";
import { fetchSessionsV2 } from "../../redux/actions";

const UpdateTask = () => {
  const currentStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentStudent) dispatch(fetchSessionsV2(currentStudent));
  }, []);

  return (
    <>
      <div className="create-tasks-container">
        <div className="heading-container">
          <h2>{Locale.t("update_session")}</h2>
        </div>
        <div className="session-main-container">
          <UpdateSession />
        </div>
      </div>
    </>
  );
};

export default UpdateTask;
